import { createSlice } from '@reduxjs/toolkit'
import { accEntryOrderInitialFields, destroyAccEntryInitialFields } from './accEntry-view.actions'
import { OrderData } from 'src/features/OrderSearch/OrderSearch.types'

type CommentsState = {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: OrderData | null
}

const initialState: CommentsState = {
  status: 'loading',
  error: null,
  data: null,
}

const accEntryInitialFields = createSlice({
  name: 'OrderAddFetchInitialFields',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [accEntryOrderInitialFields.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [accEntryOrderInitialFields.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
      state.error = null
    },
    [accEntryOrderInitialFields.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.data = null
      state.error = action.payload
    },
    [destroyAccEntryInitialFields.toString()]: () => {
      return {
        ...initialState,
      }
    },
  },
})

export default accEntryInitialFields.reducer
